"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLOR_DISTANCE_THRESHOLD = exports.UIColors = void 0;
var tinycolor_1 = require("@ctrl/tinycolor");
exports.UIColors = {
    dark: new tinycolor_1.TinyColor("#000"),
    light: new tinycolor_1.TinyColor("#fff"),
    darkAlt: new tinycolor_1.TinyColor("#111"),
    lightAlt: new tinycolor_1.TinyColor("#eee"),
};
exports.COLOR_DISTANCE_THRESHOLD = 20;
